import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import Logo from "ui-component/Logo";
import "./header.css";

const screens = [
  { label: "Home", to: "/" },
  { label: "Solutions", to: "/solutions" },
  { label: "Developers", to: "/developers" },
  { label: "About", to: "/about" },
];

const Header = () => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => setOpen(false), [pathname]);

  return (
    <div className={`topbar${open ? " open" : ""}`}>
      <div className="topbar-inner">
        <Logo />
        <button
          type="button"
          className="menu-toggle"
          aria-label={open ? "Close menu" : "Open menu"}
          aria-expanded={open}
          aria-controls="site-menu"
          onClick={() => setOpen((o) => !o)}
        >
          <span />
          <span />
          <span />
        </button>
        <div id="site-menu" className="menu">
          <nav className="screens">
            {screens.map(({ label, to }) => (
              <NavLink key={to} to={to} end>
                {label}
              </NavLink>
            ))}
          </nav>
          <div className="nav-right">
            <Link to="/contact" className="cta-pill">
              Get started
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
